import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen flex items-center justify-center px-4 bg-clay-bg">
      <motion.div
        data-testid="payment-cancel-card"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-md w-full border border-clay-border bg-clay-card p-10 text-center"
      >
        <XCircle className="w-16 h-16 text-clay-muted mx-auto mb-6" />
        <h1 className="font-display font-black uppercase text-4xl tracking-tight mb-4">Checkout Cancelled</h1>
        <p className="text-clay-muted text-sm mb-8">
          No charge was made. Whenever you're ready, your $35 season membership keeps the Darlington clay flying.
        </p>
        <Link
          data-testid="cancel-home-link"
          to="/"
          className="inline-block bg-clay-orange hover:bg-clay-gold text-clay-bg font-display font-bold uppercase tracking-wider px-8 py-4 transition-colors duration-300"
        >
          Try Again
        </Link>
      </motion.div>
    </main>
  );
}
